import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { connect } from "react-redux";

import withRouter from "../../Components/wrappers/with-router";
import UnpActions from "../../Stores/redux/UnPersist/Actions";
import PActions from "../../Stores/redux/Persist/Actions";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../Components/Models/confirmation-modal";
import { PureAppComponent } from "../../Components/AppComponent";
import { logout } from "../../Modules/auth/logout";

const SCREEN_NAME = "NAVBAR";

class NavBar extends PureAppComponent {
  render() {
    const {
      props: { activeLink },
    } = this;

    return (
      <Navbar bg="dark" variant="dark" expand="lg" className="topnavbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            TN Lender
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="topnavbar-nav" />
          <Navbar.Collapse id="topnavbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" active={activeLink === "/"}>
                Dashboard
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/transaction"
                active={activeLink === "/transaction"}
              >
                Transactions
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/account"
                active={activeLink === "/account"}
              >
                Accounts
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/customer"
                active={activeLink === "/customer"}
              >
                Customers
              </Nav.Link>
              <Nav.Link as={Link} to="/agent" active={activeLink === "/agent"}>
                Agents
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/expense"
                active={activeLink === "/expense"}
              >
                Expenses
              </Nav.Link>

              <Nav>
                <NavDropdown
                  title="Reports"
                  id="topnav-user-dropdown"
                  align="end"
                  active={activeLink === "/report"}
                >
                  <NavDropdown.Item as={Link} to="/report/balancesheet/loan">
                    Monthly Balance Sheet for Loan
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/report/balancesheet/deposit">
                    Monthly Balance Sheet for Deposit
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/report/paid-unpaid">
                    Paid/Unpaid Accounts
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/report/byreturningdate">
                    Deposit Accounts By Returning Date
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/report/agentcommission">
                    Agent Commission
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/report/pnl">
                    Profit and Loss Report
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Nav>
            <Nav>
              <NavDropdown
                title="User"
                id="topnav-user-dropdown"
                align="end"
                active={activeLink === "/user"}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/profile"
                  active={activeLink === "/profile"}
                >
                  Profile
                </NavDropdown.Item>

                <NavDropdown.Divider />
                <LogoutButton />
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

class LogoutButton extends PureAppComponent {
  logout() {
    this.setAsyncState({ showModal: false });
    logout();
  }

  render() {
    return (
      <>
        <NavDropdown.Item
          onClick={() => this.setAsyncState({ showModal: true })}
        >
          Logout
        </NavDropdown.Item>
        <ConfirmationModal
          visible={!!this.state.showModal}
          handleClose={() => this.setAsyncState({ showModal: false })}
          onSubmit={this.logout.bind(this)}
          body="Are you sure you want to logout ?"
          submitBtnText="Logout"
          title="Confirm Logout"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  screenState: state.vState[SCREEN_NAME] || {},
  user: state.pState.user.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar));
